export default __webpack_public_path__ + "locales/lo-LA/PDFFormDialog.json?hash=616b28045e459099120b4570f7fc3758";